// extracted by mini-css-extract-plugin
var _1 = "BY79gFWnwq73rKu_pOg3";
var _2 = "t3ZmlOdWnIpxT4NfbSs4";
var _3 = "_6RNAhrwCGjzEa4Sz3kc";
var _4 = "uFqcUtU3tElpUDP1XtlM";
var _5 = "VUVTsN8VK0djRX3JEriq";
var _6 = "yombp5f29cyN9c6hBlz1";
var _7 = "lmmkAlUmMlwpN7LojF9o";
var _8 = "m92aibs72zyrYnhlDJLx";
export { _1 as "body", _2 as "chevron", _3 as "chevronOpen", _4 as "inlineIcon", _5 as "legend", _6 as "summary", _7 as "summaryText", _8 as "toggle" }
